
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class InfoState extends Vue {
  @Prop({ default: null })
  private readonly icon!: string | null;
}
